var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            var BestTourHelper = function () {
                function BestTourHelper(rootSelector) {
                    _classCallCheck(this, BestTourHelper);

                    this.root = document.querySelector(rootSelector);
                }

                _createClass(BestTourHelper, [{
                    key: "init",
                    value: function init() {
                        if (!this.root) {
                            return;
                        }

                        this.root.classList.add('best-tour-helper--ready');
                        this.bindEvents();
                    }
                }, {
                    key: "bindEvents",
                    value: function bindEvents() {
                        document.addEventListener('click', this.handleClick.bind(this));
                    }
                }, {
                    key: "handleClick",
                    value: function handleClick(event) {
                        var whatsappButton = event.target.closest('.js_open-web-whatsapp');
                        var appButton = event.target.closest('.js_open-app-modal');

                        if (whatsappButton) {
                            this.openWhatsapp(whatsappButton);
                            return;
                        }

                        if (appButton) {
                            this.track('open_app_qr_modal', {
                                Place: appButton.dataset.place || 'best-tour-helper'
                            });
                            this.openAppModal();
                        }
                    }
                }, {
                    key: "openWhatsapp",
                    value: function openWhatsapp(button) {
                        var whatsAppLink = this.resolveWhatsappLink(button);

                        if (!whatsAppLink) {
                            return;
                        }

                        this.track('write-to-whatsapp-click', {
                            Place: button.dataset.place || null
                        });

                        window.open(whatsAppLink, '_blank', 'noopener');
                    }
                }, {
                    key: "openAppModal",
                    value: function openAppModal() {
                        if (!window.modal || typeof window.modal.open !== 'function') {
                            return;
                        }

                        var content = document.getElementById('appModal');

                        if (!content) {
                            return;
                        }

                        window.modal.open({
                            header: {
                                title: ''
                            },
                            content: {
                                htmlDetachSelectorId: 'appModal'
                            },
                            parentCssClass: 'best-tour-helper-app-modal',
                            type: window.modal.types.FLOATING,
                            footer: null
                        });
                    }
                }, {
                    key: "resolveWhatsappLink",
                    value: function resolveWhatsappLink(button) {
                        var helper = button.closest('.best-tour-helper');
                        var qrCode = helper ? helper.querySelector('.js-qr-code') : null;
                        var qrContent = qrCode && qrCode.dataset ? qrCode.dataset.qrContent : null;

                        if (qrContent) {
                            return qrContent;
                        }

                        var phone = this.resolveWhatsappPhone();

                        if (!phone) {
                            return null;
                        }

                        var cleanPhone = String(phone).replace(/\D/g, '');

                        return 'https://web.whatsapp.com/send?phone=' + cleanPhone + '&text=';
                    }
                }, {
                    key: "resolveWhatsappPhone",
                    value: function resolveWhatsappPhone() {
                        if (typeof window.getWhatsappPhone === 'function') {
                            return window.getWhatsappPhone();
                        }

                        if (!window.app || !window.app.citiesWhatsAppPhones || !window.app.defaultCity) {
                            return null;
                        }

                        var userCityId = this.getCookieByName('city_id') || window.app.defaultCity.id;

                        return window.app.citiesWhatsAppPhones[userCityId] || window.app.citiesWhatsAppPhones[window.app.defaultCity.id] || window.app.onlineDepartmentWhatsappPhone || null;
                    }
                }, {
                    key: "getCookieByName",
                    value: function getCookieByName(name) {
                        var escapedName = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
                        var matches = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));

                        return matches ? decodeURIComponent(matches[1]) : null;
                    }
                }, {
                    key: "track",
                    value: function track(name, properties) {
                        if (window.brxTracking && typeof window.brxTracking.sendAnalyticsEvent === 'function') {
                            window.brxTracking.sendAnalyticsEvent(name, properties || {});
                        }
                    }
                }]);

                return BestTourHelper;
            }();

            new BestTourHelper('.best-tour-helper').init();
        })();
    }, {}] }, {}, [1]);